import { render, staticRenderFns } from "./DeviceIndex.vue?vue&type=template&id=4fbef8f1&scoped=true&"
import script from "./DeviceIndex.vue?vue&type=script&lang=js&"
export * from "./DeviceIndex.vue?vue&type=script&lang=js&"
import style0 from "./DeviceIndex.vue?vue&type=style&index=0&id=4fbef8f1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbef8f1",
  null
  
)

export default component.exports